<template>
    <div>
      <a-form id="formLogin"
                class="user-layout-login"
                ref="formLogin"
                :form="form">
          <!--大框  -->
              <!-- 手机号 -->
               
          <!-- 自动登录、忘记密码 -->
          <!-- 忘记密码无页面!!! -->
          <!-- <a-form-item>
            <a-checkbox v-decorator="['rememberMe', { valuePropName: 'checked' }]">{{ $t('user.login.remember-me') }}</a-checkbox>
            <router-link :to="{ name: 'recover', params: { user: 'aaa'} }"
                         class="forge-password"
                         style="float: right;">{{ $t('user.login.forgot-password') }}</router-link>
          </a-form-item> -->
    
          <!--  登录按钮  -->
          <a-alert
            message="重置密码"
            description="成功"
            type="info"
            show-icon
            style="margin-bottom: 30px;"
            />
          <a-form-item>
            <a-button 
            style="width: 100%;margin-top: 2px;"
            size="large"
                      type="primary"
                      htmlType="submit"
                      class="login-button"
                      :loading="state.loginBtn"
                      :disabled="state.loginBtn">前往登录</a-button>
        
            
          </a-form-item>
        </a-form>
    </div>
  </template>
  
  <script>
  export default {
      data() {
        return {
          form: this.$form.createForm(this),
          customActiveKey: 'account',
          state: {
            time: 60,
            loginBtn: false,
            // login type: 0 email, 1 username, 2 telephone
            loginType: 0,
            smsSendBtn: false
          }
        }
      },
  }
  </script>
  
  <style>
    .getCaptcha {
        display: block;
        width: 100%;
        height: 50px;
      }
      .steps {
      max-width: 550px;
      margin: 16px auto;
    }
  </style>